import { html } from 'lit';
import { actionLink } from '../components/actionLink.js';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const costSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="kosten"
    class=${editorNodeClass(editor, 'section.costs', 'vp-section vp-cost-section')}
    style=${editorNodeStyle(editor, 'section.costs')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.costs', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.costs', event)}
  >
    <div class="vp-shell vp-cost-layout">
      <div>
        ${sectionHeading({
          eyebrow: content.costs.eyebrow,
          title: content.costs.title,
          highlight: content.costs.titleHighlight,
          text: content.costs.text,
          editor,
          elementPrefix: 'costs',
        })}
        <div class="vp-section-actions">
          ${actionLink({ action: content.hero.primaryAction, editor, elementId: 'costs.primaryAction.label' })}
        </div>
      </div>

      <div
        class=${editorNodeClass(editor, 'costs.panel', 'vp-cost-panel reveal-card')}
        style=${editorNodeStyle(editor, 'costs.panel')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'costs.panel', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'costs.panel', event)}
      >
        <div
          class=${editorNodeClass(editor, 'costs.included.container')}
          style=${editorNodeStyle(editor, 'costs.included.container')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'costs.included.container', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'costs.included.container', event)}
        >
          <h3
            class=${editorNodeClass(editor, 'costs.includedTitle')}
            style=${editorNodeStyle(editor, 'costs.includedTitle')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'costs.includedTitle', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'costs.includedTitle', event)}
          >
            ${content.costs.includedTitle}
          </h3>
          <ul>
            ${content.costs.included.map(
              (item, index) => html`
                <li>
                  <span class="icon-[material-symbols--add-circle]"></span>
                  <span
                    class=${editorNodeClass(editor, `costs.included.${index}`)}
                    style=${editorNodeStyle(editor, `costs.included.${index}`)}
                    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `costs.included.${index}`, event)}
                    @click=${(event: MouseEvent) => editorNodeClick(editor, `costs.included.${index}`, event)}
                  >
                    ${item}
                  </span>
                </li>
              `,
            )}
          </ul>
        </div>
        <div
          class=${editorNodeClass(editor, 'costs.excluded.container')}
          style=${editorNodeStyle(editor, 'costs.excluded.container')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'costs.excluded.container', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'costs.excluded.container', event)}
        >
          <h3
            class=${editorNodeClass(editor, 'costs.excludedTitle')}
            style=${editorNodeStyle(editor, 'costs.excludedTitle')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'costs.excludedTitle', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'costs.excludedTitle', event)}
          >
            ${content.costs.excludedTitle}
          </h3>
          <ul>
            ${content.costs.excluded.map(
              (item, index) => html`
                <li>
                  <span class="icon-[material-symbols--check-circle]"></span>
                  <span
                    class=${editorNodeClass(editor, `costs.excluded.${index}`)}
                    style=${editorNodeStyle(editor, `costs.excluded.${index}`)}
                    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `costs.excluded.${index}`, event)}
                    @click=${(event: MouseEvent) => editorNodeClick(editor, `costs.excluded.${index}`, event)}
                  >
                    ${item}
                  </span>
                </li>
              `,
            )}
          </ul>
        </div>
      </div>
    </div>
  </section>
`;
